import { render, staticRenderFns } from "./GDSReportViewer.vue?vue&type=template&id=12c797a1&lang=pug"
import script from "./GDSReportViewer.vue?vue&type=script&lang=js"
export * from "./GDSReportViewer.vue?vue&type=script&lang=js"
import style0 from "./GDSReportViewer.vue?vue&type=style&index=0&id=12c797a1&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12c797a1')) {
      api.createRecord('12c797a1', component.options)
    } else {
      api.reload('12c797a1', component.options)
    }
    module.hot.accept("./GDSReportViewer.vue?vue&type=template&id=12c797a1&lang=pug", function () {
      api.rerender('12c797a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/my-objects/GDSReportViewer.vue"
export default component.exports